module.exports = function( $scope, $ ) {
	kitbuilderFrontend.waypoint( $scope.find( '.kitbuilder-progress-bar' ), function() {
		var $progressbar = $( this );

		$progressbar.css( 'width', $progressbar.data( 'max' ) + '%' );
	}, { offset: '90%' } );
};
